import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
export default function SliderAnaylsis(props) {

  const StatusTruePre = (props.StatuesTrue / 18) * 100
  const StatusCorrectPre = (props.StatusCorrect / 18) * 100
  const StatusFalsePre = (props.StatusFalse / 18) * 100

  return (
    <div>
        <p style={{textAlign:"center",color:"#4eb54c"}}>{props.title}</p>
        <div style={{display:"flex",justifyContent:"space-between",marginTop:"18px",minWidth:"300px"}}>
            <div><FiberManualRecordIcon style={{color:"#e74b3b"}} />
            <p>خطأ</p></div>
            <div><FiberManualRecordIcon style={{color:"#f39c12"}}/><p>تحسين</p></div>
            <div><FiberManualRecordIcon sx={{color:"#27ae60"}}/><p>مرت</p></div>
        </div>
    <Box sx={{ marginTop:"20px",minWidth:"300px" }}>
        <div style={{display:"flex"}}>
      <Slider
        value={StatusTruePre}
        aria-label="Small"
        valueLabelDisplay="auto"
        sx={{color:"#27ae60",direction:"rtl"}}
      />
       <CheckIcon style={{color:"#27ae60",marginLeft:"7px"}}/>
      </div>
      <div style={{display:"flex"}}>
        <Slider
        value={StatusCorrectPre}
        aria-label="Small"
        valueLabelDisplay="auto"
        sx={{color:"#f39c12"}}
      />
      <PriorityHighIcon style={{color:"#f39c12",marginLeft:"7px"}}/>
      </div>
      <div style={{display:"flex"}}>
        <Slider
        value={StatusFalsePre}
        aria-label="Small"
        valueLabelDisplay="auto"
        sx={{color:"#e74b3b"}}
      />
      <ClearIcon style={{color:"#e74b3b",marginLeft:"7px"}} />
      </div>
    </Box>
    </div>
  )
}
